import { GRNStatus } from 'src/models/enums/GRNStatus.enum';
import { GRNPaymentStatus } from 'src/models/enums/GRNStatus.enum';
import { ChequeStatus, PaymentMode } from 'src/models/enums/PaymentMode.enum';
import { OrderPaymentStatus } from 'src/models/OrderPayment.interface';
import { VoucherPaymentStatus } from 'src/models/VoucherPayment.interface';

export const getGRNStatusText = (status: GRNStatus | number): string => {
  switch (status) {
    case GRNStatus.NEW:
      return 'New';
    case GRNStatus.PENDING:
      return 'Pending';
    case GRNStatus.APPROVED:
      return 'Approved';
    case GRNStatus.REJECTED:
      return 'Rejected';
    case GRNStatus.PAYMENT_PROGRESS:
      return 'Payment Progress';
    case GRNStatus.PAID:
      return 'Paid';
    default:
      return 'Unknown';
  }
};

export const getPaymentStatusText = (
  status: GRNPaymentStatus | number
): string => {
  switch (status) {
    case GRNPaymentStatus.PENDING_APPROVAL:
      return 'Pending Approval';
    case GRNPaymentStatus.APPROVED:
      return 'Approved';
    case GRNPaymentStatus.REJECTED:
      return 'Rejected';
    case GRNPaymentStatus.PAID:
      return 'Paid';
    default:
      return 'Unknown';
  }
};

export const getPaymentModeText = (mode: PaymentMode | number): string => {
  switch (mode) {
    case PaymentMode.CASH:
      return 'Cash';
    case PaymentMode.CHEQUE:
      return 'Cheque';
    case PaymentMode.ONLINE:
      return 'Online';
    default:
      return 'Unknown';
  }
};

export const getVoucherPaymentStatusText = (
  status: VoucherPaymentStatus | string
): string => {
  if (typeof status === 'string') {
    return status;
  }
  return 'Unknown';
};

export const getOrderPaymentStatusText = (
  status: OrderPaymentStatus | number | string
): string => {
  if (typeof status === 'string') {
    return status;
  }
  switch (status) {
    case OrderPaymentStatus.PENDING_APPROVAL:
      return 'Pending Approval';
    case OrderPaymentStatus.APPROVED:
      return 'Approved';
    case OrderPaymentStatus.REJECTED:
      return 'Rejected';
    case OrderPaymentStatus.PAID:
      return 'Paid';
    default:
      return 'Unknown';
  }
};

export const getChequeStatusText = (
  status: ChequeStatus | number | null | undefined
): string => {
  switch (status) {
    case ChequeStatus.ISSUED:
      return 'Issued';
    case ChequeStatus.REALIZED:
      return 'Realized';
    case ChequeStatus.RETURNED:
      return 'Returned';
    case ChequeStatus.CANCELLED:
      return 'Cancelled';
    default:
      return '-';
  }
};
